export default __webpack_public_path__ + "static/media/secon3.9fd82891.jpg";